import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import CreateRFQSuppliers from "../../../Components/Modal/supplier_app/Sourcing/CreateRFQSuppliers";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import {
  checkTimeDifference,
  isValidNumber,
} from "../../../common/Validations";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import Constants from "../../../common/SupplierConstants";
import { MultiselectField } from "../../../Components/formElements/MultiselectField";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import BuyerAuctionFormModal from "./BuyerAuctionFormModal";
import AuctionLineItemTable from "./AuctionLineItemTable";
import moment from "moment";
import PageLevelRiverseTimer from "../../../Components/PageLevelRiverseTimer";
const LiveReverseAuctionDetail = () => {
  let rfxNr = useSelector((state) => state?.sourcing?.rfq?.rfxNr); // User Details from Store

  let auctionId = useSelector(
    (state) => state.eauctionSlice.eauction.auctionNr
  );
  // console.log("auctionId",auctionId)
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [editorContent, setEditorContent] = useState("");
  // eslint-disable-next-line
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  // const [getRFxType, setRFxType] = useState([]);
  // eslint-disable-next-line
  const [getINCOTerms, setINCOTerms] = useState([]);
  // eslint-disable-next-line
  const [getcurrency, setcurrency] = useState([]);
  // eslint-disable-next-line
  const [getLineItemData, setLineItemData] = useState([]);
  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] =
    useState(false);
  const [getFormModalData, setFormModalData] = useState({});
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [formInputs, setFormInputs] = useState({});
  console.log(">>formInputs", formInputs);

  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    totalHour: "",
    status: false,
    msg: "",
  });

  const modalData = {
    title: "RFQ Creation",
    successMsg: "",
  };

  const [finalTimerValue, setFinalTimerValue] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const updateTimerValue = (closingDateTime) => {
    let timerData = {};
    const openingMoment = moment(); // current time
    const closingMoment = moment(closingDateTime, "YYYY-MM-DD HH:mm");
    const diffInMilliseconds = closingMoment.diff(openingMoment);
    const duration = moment.duration(diffInMilliseconds);

    if (diffInMilliseconds <= 0) {
      setFinalTimerValue({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
    } else {
      timerData.days = Math.floor(duration.asDays()) || 0;
      timerData.hours = duration.hours() || 0;
      timerData.minutes = duration.minutes() || 0;
      timerData.seconds = duration.seconds() || 0;
      setFinalTimerValue(timerData);
    }
  };

  useEffect(() => {
    if (!getOpenCloseInput?.closingDate || !getOpenCloseInput?.closingTime)
      return;

    const closingDateTime = `${getOpenCloseInput.closingDate} ${getOpenCloseInput.closingTime}`;
    updateTimerValue(closingDateTime); // initial call

    const interval = setInterval(() => {
      updateTimerValue(closingDateTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [getOpenCloseInput]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  // const toggleCardVisibility3 = () => {
  //   setCardVisible3(!isCardVisible3);
  // };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };

  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // This is for Text Editor
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };
  // eslint-disable-next-line
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const [selectedINCOTerms, setSelectedINCOTerms] = useState([]); // Selected ones (from API)

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.textField === "paymentTerm") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "INCOTerms") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        INCOTerms: getDropdownData?.name,
        INCOTermsCode: getDropdownData?.code,
        INCOTermsDesc: getDropdownData?.description,

        incoTerms: getDropdownData?.selected, // ✅ store full selected array
      }));
    } else if (getDropdownData?.textField === "auctionCurrencies") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        auctionCurrencies: getDropdownData?.name,
        auctionCurrenciesCode: getDropdownData?.code,
        auctionCurrenciesDesc: getDropdownData?.description,

        auctionCurrencie: getDropdownData?.selected, // ✅ store full selected array
      }));
    } else if (getDropdownData?.textField === "othercurrencies") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        othercurrencies: getDropdownData?.name,
        othercurrenciesCode: getDropdownData?.code,
        othercurrenciesDesc: getDropdownData?.description,

        othercurrencie: getDropdownData?.selected, // ✅ store full selected array
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  /* submit button */
  // eslint-disable-next-line

  const loadInitialPageData = async () => {
    if (auctionId) {
      let obj = {
        documentNumber: auctionId,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      try {
        const item = await ItemService.getAuctionDetail(obj);
        if (item?.status === 200) {
          const response = item.data[0];
          setFormInputs(response);
          updateTimerValue(item?.data[0]?.closingDateTime);
          // setFormInputs((prev) => {
          //     return {
          //         ...prev,
          //         ...response,
          //     };
          // });
          setOpenCloseInput(() => {
            return {
              openingTime: response.openingTime,
              closingDate: response.closingDate,
              closingTime: response.closingTime,
              openingDate: response.openingDate,
            };
          });
          // Optional: map extra arrays to state
          // if (response.items) setData(response.items);
          // if (response.formCOMM) setDynamicFormDataCOMM(response.formCOMM);
          // if (response.formTECH) setDynamicFormDataTECH(response.formTECH)
          if (response.instructions) setEditorContent(response.instructions);
          if (response.termsConditions)
            setTermsConditionsData(response.termsConditions);
          if (response.bidders) setBiddersData(response.bidders);
          if (response.items) setLineItemsData(response.items);
          if (response.incoTerms) setINCOTerms(response?.incoTerms);
          if (response.incoTerms) {
            setSelectedINCOTerms(response.incoTerms);
            if (response.buyerContact) {
              setbuyerContactData(response.buyerContact);
              // setFormInputs((prev) => ({
              //     ...prev,
              //     buyerContact: response.buyerContact,
              // }));
            }
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      } catch (err) {
        console.error("API call error:", err);
        toast.error("Something went wrong", {
          duration: 4000,
          position: "top-right",
        });
      } finally {
        toast.dismiss(toastId);
      }
    } else {
      console.warn("auctionId is missing, cannot load data.");
    }
  };
  useEffect(
    (auctionId) => {
      loadInitialPageData();
    },
    // eslint-disable-next-line
    [auctionId]
  );

  const loadExchangeRateData = async () => {
    let obj = {
      queryName: "getExchangeRateDetails",
      // documentNumber: rfxNr,
      documentNumber: "RFX0059",
    };
    await ItemService.generateQuery(obj).then((item) => {
      console.log(">> res!", item);
      if (item?.status === 200) {
        // setTechnicalEvalHeaderData(item?.data[0]);
        setTimeout(() => {
          // console.log(">> setTechData", item?.data);
          // setTechData(item?.data);
          setauctionLineItemData(item?.data);
        }, 1000);
        setExchangeRateData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };
  const loadCommercialEvaluationData = async () => {
    if (true) {
      let obj = {
        queryName: "getRFXCommEvaluationDetail",
        // rfxNr: rfxNr,
        rfxNr: "RFX9107",
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.generateQuery(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          // Suppose "data" is your response array (item.data)
          const data = item?.data[0]?.supplierList || [];
          // 1. Sort a copy by qtnSubTotalLineItem
          const sorted = [...data].sort(
            (a, b) => a.qtnSubTotalLineItem - b.qtnSubTotalLineItem
          );
          // 2. Create a Map from value to rank (handles ties)
          const valueToRank = new Map();
          let rank = 1;
          for (let i = 0; i < sorted.length; i++) {
            const value = sorted[i].qtnSubTotalLineItem;
            if (!valueToRank.has(value)) {
              valueToRank.set(value, rank);
              rank++;
            }
          }
          // setFormInputs(item.data[0]);
          setFormInputs((prev) => ({
            ...prev,
            ...item.data[0],
          }));
          setTimeout(() => {
            // setTechData(item?.data);
            setauctionLineItemData(item?.data);
          }, 500);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      // setLoading(false);
    } else {
      // window.history.back();
    }
  };
  const handleItemData = (data) => {
    // console.log(">> item tech ", data);
    // setItemTableData(data);
    setFormInputs((formInputs) => ({
      ...formInputs,
      items: data,
    }));
  };
  useEffect(() => {
    // loadInitialPageData();
    loadCommercialEvaluationData();
    // loadTechUser();
    loadExchangeRateData();
    // eslint-disable-next-line
  }, [rfxNr]);

  /* suppplierModalShow */
  const [getSupplierModal, setSupplierModal] = useState(false);

  const supplerMoadHide = () => {
    setSupplierModal(false);
  };
  /* selectedSupplierIds */
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  // eslint-disable-next-line
  const [getSupplierData, setSupplierData] = useState([]);
  const handleSelectedRows = (selectedRows) => {
    setSelectedSuppliers(selectedRows);
  };

  const handlePassDataToParent = (data) => {
    setSupplierData((prevData) => {
      // Combine previous data and filter out duplicates based on id
      const updatedData = [
        ...prevData,
        ...data.filter(
          (newObj) =>
            !prevData.some(
              (existingObj) =>
                existingObj.AssociateNumber === newObj.AssociateNumber
            )
        ),
      ];

      return updatedData;
    });
  };
  // eslint-disable-next-line
  const [termsConditionsData, setTermsConditionsData] = useState([
    {
      id: 1,
      name: "Terms and Conditions",
      status: true,
      disabled: true,
    },
    {
      id: 2,
      name: "Code of Conduct",
      status: false,
    },
    {
      id: 3,
      name: "Packaging Requirement",
      status: false,
    },
    {
      id: 4,
      name: "Others",
      status: false,
    },
  ]);

  /*  Buyer Line Items*/
  let BuyerContactCol = [
    {
      name: "Document Item Nr",
      // selector: (row) => row.local_id || "--",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "180px",
    },

    {
      name: "Buyer Name ",
      selector: (row) => row.buyerName || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="buyerName"
          placeholder=""
          value={row.buyerName || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Buyer Email ",
      selector: (row) => row.buyerEmail || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="buyerEmail"
          placeholder=""
          value={row.buyerEmail || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Mobile Number ",
      selector: (row) => row.buyerNumber || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="buyerNumber"
          placeholder=""
          value={row.buyerNumber || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getDisabled}
        />
      ),
      sortable: true,
      width: "300px",
    },

    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let buyerContactData = [
    {
      local_id: 1,
      // rfxNr: 1,
      buyerEmail: "",
      buyerName: "",
      buyerNumber: "",
    },
  ];

  /*  Buyer Line Items*/
  let lineItems = [
    {
      name: "Document Item Nr",
      // selector: (row) => row.local_id || "--",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Item No",
      selector: (row) => row.itemNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemNo"
          value={row.itemNo || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "PR Number",
      selector: (row) => row.prNumber || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="prNumber"
          value={row.prNumber || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "PR Line",
      selector: (row) => row.prLine || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="prLine"
          value={row.prLine || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Item Code",
      selector: (row) => row.itemCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCode"
          value={row.itemCode || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Description",
      selector: (row) => row.itemDescription || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemDescription"
          value={row.itemDescription || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Item Text",
      selector: (row) => row.itemText || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemText"
          value={row.itemText || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="quantity"
          value={row.quantity || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "150px",
    },
    {
      name: "UOM",
      selector: (row) => row.uom || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="uom"
          value={row.uom || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "120px",
    },
    {
      name: "Internal Rate",
      selector: (row) => row.internalRate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="internalRate"
          value={row.internalRate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Item Value",
      selector: (row) => row.itemValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemValue"
          value={row.itemValue || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "RFQ Value(Min)",
      selector: (row) => row.rfqValueMin || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="rfqValueMin"
          value={row.rfqValueMin || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Ceiling Price",
      selector: (row) => row.ceilingPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="ceilingPrice"
          value={row.ceilingPrice || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Auction Value",
      selector: (row) => row.auctionValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="auctionValue"
          value={row.auctionValue || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Requested Delivery Date",
      selector: (row) => row.requestedDeliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="requestedDeliveryDate"
          value={row.requestedDeliveryDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service Header Code",
      selector: (row) => row.serviceHeaderCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="serviceHeaderCode"
          value={row.serviceHeaderCode || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service Start Date",
      selector: (row) => row.serviceStartDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="serviceStartDate"
          value={row.serviceStartDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Service End Date",
      selector: (row) => row.serviceEndDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="serviceEndDate"
          value={row.serviceEndDate || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Technical Specification",
      selector: (row) => row.technicalSpec || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="technicalSpec"
          value={row.technicalSpec || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "INCO Terms",
      selector: (row) => row.incoTerms || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="incoTerms"
          value={row.incoTerms || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "INCO Terms Location",
      selector: (row) => row.incoTermsLoc || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="incoTermsLoc"
          value={row.incoTermsLoc || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "220px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRowLineItem(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let lineItemsData = [
    {
      local_id: 1,
      rfxNr: 1,
      itemNo: "",
      prNumber: "",
      prLine: "",
      itemCode: "",
      itemDescription: "",
      itemText: "",
      quantity: "",
      uom: "",
      internalRate: "",
      itemValue: "",
      rfqValueMin: "",
      ceilingPrice: "",
      auctionValue: "",
      requestedDeliveryDate: "",
      serviceHeaderCode: "",
      serviceStartDate: "",
      incoTerms: "",
      serviceEndDate: "",
      technicalSpec: "",
      incoTermsLoc: "",
    },
  ];
  // Bidders Line Items
  let bidderColumData = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "80px",
    },
    {
      name: "Supplier Code and Name",
      selector: (row) => row.supplierCodeAndName || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="supplierCodeAndName"
          value={row.supplierCodeAndName || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Country",
      selector: (row) => row.country || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="country"
          value={row.country || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "180px",
    },
    {
      name: "Email ID",
      selector: (row) => row.emailId || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="emailId"
          value={row.emailId || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "250px",
    },
    {
      name: "Contact No",
      selector: (row) => row.contactNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="contactNo"
          value={row.contactNo || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "User ID",
      selector: (row) => row.userId || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="userId"
          value={row.userId || ""}
          onChange={(e) => handleBiddersInputChange(row.local_id, e)}
          disabled={getDisabled}
        />
      ),
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRowBiddersItem(row.local_id)}
          disabled={getDisabled}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let biddersLineItemData = [
    {
      local_id: 1,
      rfxNr: 1,
      supplierCodeAndName: "",
      country: "",
      emailId: "",
      contactNo: "",
      userId: "",
      // delete: ""
    },
  ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  const aAuctionCOmpanyCOde = [
    {
      id: 1,
      desc: "",
      name: "SV",
      code: "",
    },
  ];
  const buyerCategories = [
    {
      id: 1,
      desc: "ProcurementDepartmentdesc",
      name: "Procurement Department",
      code: "ProcurementDepartmentcode",
    },
    {
      id: 1,
      desc: "PurchaseManagerdesc",
      name: "Purchase Manager",
      code: "PurchaseManagercode",
    },
    {
      id: 1,
      desc: "ProjectManagerdesc",
      name: "Project Manager",
      code: "ProjectManagercode",
    },
    {
      id: 1,
      desc: "FinanceDepartmentdesc",
      name: "Finance Department",
      code: "FinanceDepartmentcode",
    },
  ];
  const bidTimeOptions = [
    {
      id: 1,
      desc: "Last 5 minutesdesc",
      name: "Last 5 minutes",
      code: "5code",
    },
    {
      id: 2,
      desc: "Last 10 minutesdesc",
      name: "Last 10 minutes",
      code: "10code",
    },
  ];
  const auctionExtendedOptions = [
    {
      id: 1,
      desc: "Last 1 minutesdesc",
      name: "Last 1 minutes",
      code: "1code",
    },
    {
      id: 2,
      desc: "Last 2 minutesdesc",
      name: "Last 2 minutes",
      code: "10code",
    },
    {
      id: 3,
      desc: "Last 5 minutesdesc",
      name: "Last 5 minutes",
      code: "5code",
    },
  ];
  const newBidReceivedOptions = [
    {
      id: 1,
      desc: "within5minutesdesc",
      name: "Within last 5 minutes of auction",
      code: "5minutescode",
    },
    {
      id: 2,
      desc: "final desc",
      name: "During final bidding round",
      code: "finalcode",
    },
    {
      id: 3,
      desc: "live Auction desc",
      name: "During live auction only",
      code: "liveAuctioncode",
    },
  ];
  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // const [finalTimerValue, setFinalTimerValue] = useState({
  //     days: 0,
  //     hours: 0,
  //     minutes: 0,
  //     seconds: 0,
  //   });

  // OnClick on lineItem  Data
  // eslint-disable-next-line
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  //buyer contat  Data
  const [getbuyerContactData, setbuyerContactData] = useState(buyerContactData);

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    setbuyerContactData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };
  const addPOItemRow = () => {
    setbuyerContactData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;

      const newRow = {
        ...buyerContactData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };

      return [...prevRows, newRow];
    });
  };
  const removePOItemRow = (local_id) => {
    setbuyerContactData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  // Line Items Data
  const [getLineItemstData, setLineItemsData] = useState(lineItemsData);
  const handleLineItemsInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value,
                  taxAmount:
                    (Number(row.taxCode) / 100) *
                    (name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value),
                }
              : row;
          })
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.purchaseQuantity || 0) *
                          Number(row.orderPriceUnit || 0))
                      : 0,
                }
              : row
          )
        );
      }
    } else {
      setLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row
        )
      );
    }
    // getTotalCount()
  };

  const addPOItemRowLineItem = () => {
    setLineItemsData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;

      const newRow = {
        ...lineItemsData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };

      return [...prevRows, newRow];
    });
  };
  const removePOItemRowLineItem = (local_id) => {
    setLineItemsData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  // Bidders Section
  const [getBiddersData, setBiddersData] = useState(biddersLineItemData);
  const handleBiddersInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setBiddersData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value,
                  taxAmount:
                    (Number(row.taxCode) / 100) *
                    (name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value),
                }
              : row;
          })
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setBiddersData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.purchaseQuantity || 0) *
                          Number(row.orderPriceUnit || 0))
                      : 0,
                }
              : row
          )
        );
      }
    } else {
      setBiddersData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row
        )
      );
    }
    // getTotalCount()
  };

  const addPOItemRowBiddersItem = () => {
    setBiddersData((prevRows) => {
      const newId =
        prevRows.length > 0
          ? Math.max(...prevRows.map((row) => row.local_id)) + 1
          : 1;

      const newRow = {
        ...biddersLineItemData[0],
        local_id: newId,
        rfxNr: String(newId).padStart(3, "0"),
      };

      return [...prevRows, newRow];
    });
  };
  const removePOItemRowBiddersItem = (local_id) => {
    setBiddersData((prevRows) =>
      prevRows.filter((row) => row.local_id !== local_id)
    );
  };

  // obj
  const getMasterDataFunc = async () => {
    let obj1 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj7 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj7).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj8 = {
      codeType: "INCOTerms",
    };
    await ItemService.getMasterData(obj8).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  useEffect(() => {
    getMasterDataFunc();

    localStorage.setItem("menu", "eAuction");
    localStorage.setItem("submenu", "Reverse Auction");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line
  const createDynamicformModelCOMM = () => {
    let obj = {
      formType: "COMM",
    };
    setCreateDynamicformModelShow(true);
    setFormModalData(obj);
  };

  const hideModalStatus = () => {
    setCreateDynamicformModelShow(false);
  };
  // eslint-disable-next-line
  const [exchangeRateData, setExchangeRateData] = useState([]);

  // Render Questions
  const onInputChangeopeningDate = ({ target: { name, value } }) => {
    setOpenCloseInput((getOpenCloseInput) => ({
      ...getOpenCloseInput,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      getOpenCloseInput.openingDate !== "" ||
      getOpenCloseInput.openingTime !== "" ||
      getOpenCloseInput.closingDate !== "" ||
      getOpenCloseInput.closingTime !== ""
    ) {
      let openDate =
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
      let closeDate =
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
      let res = checkTimeDifference(openDate, closeDate);
      // console.log(">> res", res);
      getOpenCloseInput.status = res.status;
      getOpenCloseInput.msg = res.msg + " '(Opening and Closing Fields)' !!";

      if (getOpenCloseInput.closingDate !== "") {
        if (res.status) {
          getOpenCloseInput.totalHour = res.totalHours;
        } else {
          toast.error(res.msg, {
            duration: 4000,
            position: "top-right",
          });
        }
      }
    }
  }, [getOpenCloseInput]);

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  //instruction Bidders
  const [sections, setSections] = useState([
    {
      id: 1,
      title: "Introduction",
      data: [
        {
          key: "1.1",
          text: "Dear Partners, We are very pleased to invite you to participate in above mentioned Emirates Steel Auction as mentioned in Auction Basic Information.",
        },
        {
          key: "1.2",
          text: "Remark: This is an online bidding, hence doesn't require submission of signed, stamped hard copy proposals. * If you have any questions, please use the messages section in the auction to communicate with the buyer. No other communication channels are available.",
        },
        {
          key: "1.3",
          text: "Deadline for the auction submission: As shown in the time ticker section on the top of the auction section.",
        },
      ],
    },
    {
      id: 2,
      title: "Information",
      data: [
        {
          key: "2.1",
          text: "Price: Use this term to input the item / material unit Price",
        },
        {
          key: "2.2",
          text: "Delivery Time: Use this term to mention the delivery / lead time (in days) for the item / material",
        },
        {
          key: "2.4",
          text: "Supplier Payment Terms: Use this term to mention your payment terms (e.g., 30 days, 45 days, etc.)",
        },
        {
          key: "2.5",
          text: "Origin of Material: Use this term to mention the country of origin for the item / material",
        },
      ],
    },
  ]);

  // eslint-disable-next-line
  const handleAddPoint = (sectionIndex) => {
    setSections((prev) => {
      const newSections = [...prev];
      const section = newSections[sectionIndex];

      const nextPointNum = (section.data.length + 1).toFixed(1);
      const nextKey = `${section.id}.${nextPointNum}`;

      section.data.push({
        key: nextKey,
        text: "",
        isInput: true,
        inputName: `${section.title.toLowerCase()}_${nextKey.replace(
          ".",
          "_"
        )}`,
      });

      return newSections;
    });
  };

  //
  const [getDisabled, setDIsabledField] = useState(false);

  useEffect(() => {
    setDIsabledField(true);
  }, []);
  // Auction Line Item Table
  const [auctionlineItemData, setauctionLineItemData] = useState([]);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Live Reverse Auction Details
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {auctionId}
              </span>
            </h2>
            <p className="subText">Live Reverse Auction Details</p>
            <hr />
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={12} md={5} lg={5}>
                      <p className="headerTitle fs-4">
                        Remaining Time for submission
                      </p>
                    </Col>
                    <Col xs={12} md={7} lg={7} className="flex justify-end">
                      <img
                        src="assets/img/stopwatch.png"
                        alt="stopwatch"
                        style={{ width: "60px", height: "58px" }}
                        className="mr-6 mt-1"
                      />
                      <PageLevelRiverseTimer timerData={finalTimerValue} />
                    </Col>
                  </Row>
                </h2>
              </div>
            </div>
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Reverse Auction Additional Information
                      </span>
                      <span className="subHeaderTitle">
                        Reverse Auction Additional Information Form
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          placeholder=""
                          data={aAuctionCOmpanyCOde}
                          id="companyCodeType"
                          iconClassName="dropdownIcon"
                          name="companyCodeType"
                          code="companyCodeTypeCode"
                          description="companyCodeTypeDesc"
                          setValue={formInputs?.companyCodeType || ""}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Payment Term"
                          placeholder=""
                          data={getpaymentTerm}
                          id="paymentTerm"
                          iconClassName="dropdownIcon"
                          name="paymentTerm"
                          setValue={formInputs.paymentTerm || ""}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="INCO Terms"
                          placeholder="Please select the INCO Terms"
                          data={getINCOTerms}
                          id="INCOTerms"
                          iconClassName="dropdownIcon"
                          name="INCOTerms"
                          setValue={selectedINCOTerms}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="INCO Terms Location"
                          name="incoTermsLocation"
                          id="incoTermsLocation"
                          placeholder=""
                          value={formInputs?.incoTermsLocation || ""}
                          onChange={onInputChange}
                          disabled={getDisabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* 02 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Additional Basic Information
                      </span>
                      <span className="subHeaderTitle">
                        Reverse Auction Basic Information Form
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tentative Start Time"
                          name="openingDate"
                          id="openingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.openingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Duration(HH:MM)"
                          name="openingTime"
                          id="openingTime"
                          type="time"
                          placeholder=""
                          value={getOpenCloseInput.openingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tentitative End Date"
                          name="closingDate"
                          id="closingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.closingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tentitative End Time(HH:MM)"
                          name="closingTime"
                          id="closingTime"
                          type="time"
                          placeholder=""
                          value={getOpenCloseInput.closingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Auction Type"
                          name="auctionType"
                          id="auctionType"
                          placeholder=""
                          value={formInputs?.auctionType || ""}
                          onChange={onInputChange}
                          // disabled={true}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Reference RFQ Number"
                          name="referenceRfqNumber"
                          id="referenceRfqNumber"
                          value={formInputs?.referenceRfqNumber || ""}
                          onChange={onInputChange}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Decrement In Auction Currency"
                          name="decrementValue"
                          id="decrementValue"
                          value={formInputs?.decrementValue || ""}
                          onChange={onInputChange}
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="Auction Currency"
                          placeholder="Please select the Other Currencies"
                          data={getcurrency}
                          id="auctionCurrencies"
                          iconClassName="dropdownIcon"
                          name="auctionCurrencies"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="Other Currency"
                          placeholder="Please select the Other Currencies"
                          data={getcurrency}
                          id="othercurrencies"
                          iconClassName="dropdownIcon"
                          name="othercurrencies"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Buyer Category"
                          data={buyerCategories}
                          name="buyerCategory"
                          id="buyerCategory"
                          setValue={formInputs?.buyerCategory}
                          getvalue={setDropdownData}
                          // onChange={onDropdownChange}
                          required
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Title"
                          name="auctionTitle"
                          id="auctionTitle"
                          placeholder=""
                          value={formInputs?.auctionTitle || ""}
                          onChange={onInputChange}
                          required
                          showTooltip
                          disabled={getDisabled}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Description"
                          name="auctionDescription"
                          id="auctionDescription"
                          value={formInputs?.auctionDescription || ""}
                          onChange={onInputChange}
                          required
                          showTooltip
                          disabled={getDisabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Line Items 06*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AI</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">
                        Reverse Auction Contact Information
                      </span>
                      <span className="subHeaderTitle">
                        Reverse Auction Contact Information Details
                      </span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {!getDisabled && (
                        <Col xs={4} md={2} lg={2} className="">
                          <button className="btnTable" onClick={addPOItemRow}>
                            +
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={BuyerContactCol}
                          data={getbuyerContactData}
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Documents 05 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Reverse Actions Rules And Settings
                      </span>
                      <span className="subHeaderTitle">
                        Reverse Actions Rules And Settings Form
                      </span>
                    </Col>
                    {/* <Col xs={2} md={1} lg={1} className="">
          <SourcingCommonFilter />
        </Col> */}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.others && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() => handleViewFile(formInputs?.others)}
                          />
                        )) ||
                          "--"}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="allowBidders"
                          >
                            Allow Bidders To Select Item For Bidding
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="allowBidders"
                            id="allowBidders"
                            checked={formInputs?.allowBidders || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                allowBidders: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.allowBidders ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="displayBidRank"
                          >
                            Display Bid Rank
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="displayBidRank"
                            id="displayBidRank"
                            checked={formInputs?.displayBidRank || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                displayBidRank: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.displayBidRank ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="ceilingPrice"
                          >
                            Celling Price
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="ceilingPrice"
                            id="ceilingPrice"
                            checked={formInputs?.ceilingPrice || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                ceilingPrice: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.ceilingPrice ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="tieBidAllowed"
                          >
                            Tie Bid Allow
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="tieBidAllowed"
                            id="tieBidAllowed"
                            checked={formInputs?.tieBidAllowed || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                tieBidAllowed: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.tieBidAllowed ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible7
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AR</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">
                        Revrse Auction Auto Extension Rules
                      </span>
                      <span className="subHeaderTitle">
                        Reverse Auction Auto Extension Rules and Settings
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible7 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="When new bid is received for the below mentioned bid level"
                          data={bidTimeOptions}
                          id="newBidReceived"
                          iconClassName="dropdownIcon"
                          name="newBidReceived"
                          setValue={formInputs?.newBidReceived}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Auction will be auto-extended by below mentioned minutes"
                          data={auctionExtendedOptions}
                          id="auctionAutoExtended"
                          iconClassName="dropdownIcon"
                          name="auctionAutoExtended"
                          setValue={formInputs?.auctionAutoExtended}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="When new bid is received for the below mentioned bid level"
                          data={newBidReceivedOptions}
                          id="newBidReceivedTime"
                          iconClassName="dropdownIcon"
                          name="newBidReceivedTime"
                          setValue={formInputs?.newBidReceivedTime}
                          getvalue={setDropdownData}
                          className="dropdownOption"
                          disabled={getDisabled}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* COMM - Spares & Operation Maintenance 08*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IB</span>
                    </Col>

                    <Col xs={8} md={6} lg={6}>
                      <span className="headerTitle">
                        Form: Instructions Bidders
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      md={5}
                      lg={5}
                      className="headerButtonAlign"
                    ></Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row></Row>
                  </div>

                  <div>
                    {sections.map((section, sectionIndex) => (
                      <Row key={section.id} className="mb-3 p-3 border rounded">
                        <Col xs={12}>
                          <h5 className="mb-3">{section.title}</h5>

                          {section.data.map((point, pointIndex) => (
                            <div key={point.key} className="p-1">
                              <strong>{point.key}</strong>{" "}
                              {point.isInput ? (
                                <Row className="align-items-center mt-1">
                                  <Col xs={12} sm={6} md={4}>
                                    <InputField
                                      name={point.inputName}
                                      value={formInputs[point.inputName] || ""}
                                      onChange={onInputChange}
                                      className="inputBox"
                                    />
                                  </Col>
                                </Row>
                              ) : (
                                point.text
                              )}
                            </div>
                          ))}

                          {/* <div className="mt-3">
                            <button
                              className="btn btnTable"
                              size="sm"
                              onClick={() => handleAddPoint(sectionIndex)}
                            >
                              + Add Point
                            </button>
                          </div> */}
                        </Col>
                      </Row>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible10
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility10}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AN</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Auction Note</span>
                      <span className="subHeaderTitle">
                        Auction RUles And Notes
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible10 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={editorContent}
                          onChange={handleEditorChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CS</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        Ceiling Price And Settings
                      </span>
                      <span className="subHeaderTitle">
                        Ceiling Price And Settings Form
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} className="mb-1 mt-2 ms-3">
                        <h4 className="fw-bold">
                          CeilingPrice <span className="text-danger">*</span>
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="lineItemWise"
                          >
                            LineItem Wise
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="lineItemWise"
                            id="lineItemWise"
                            checked={formInputs?.lineItemWise || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                lineItemWise: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.lineItemWise ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="supplierWise"
                          >
                            Supplier Wise
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="supplierWise"
                            id="supplierWise"
                            checked={formInputs?.supplierWise || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                supplierWise: e.target.checked,
                              }))
                            }
                            disabled={getDisabled}
                          />
                          <span className="ms-2">
                            {formInputs?.supplierWise ? "Yes" : "No"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IB</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Items For Bidding</span>
                      <span className="subHeaderTitle">
                        Auction Contact Information Details
                      </span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {!getDisabled && (
                        <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={addPOItemRowLineItem}
                          >
                            +
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={lineItems}
                          data={getLineItemstData}
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* items For Bidding */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BS</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Bidders</span>
                      <span className="subHeaderTitle">Bidders Section</span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {!getDisabled && (
                        <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={addPOItemRowBiddersItem}
                          >
                            +
                          </button>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={bidderColumData}
                          data={getBiddersData}
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Line Items */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible10
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility10}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>

                    <Col xs={4} md={8} lg={7}>
                      <span className="headerTitle">Line Item</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible10 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body autoScroll">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <AuctionLineItemTable
                          data={auctionlineItemData}
                          sendDataToParent={handleItemData}
                          //   pageStatus={getDisabledStatus}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CreateRFQSuppliers
        show={getSupplierModal}
        onHide={supplerMoadHide}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />

      <BuyerAuctionFormModal
        show={getCreateDynamicformModelShow}
        onHide={() => hideModalStatus()}
        modeldata={getFormModalData}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default LiveReverseAuctionDetail;
